import type { ChaveMes } from '@/dados';

/* O eixo de meses da etapa: as doze chaves gravadas, como se lê cada uma na
   tela e o que uma linha do formulário carrega enquanto é digitada. */

export const CHAVES: readonly ChaveMes[] = [
  'm01',
  'm02',
  'm03',
  'm04',
  'm05',
  'm06',
  'm07',
  'm08',
  'm09',
  'm10',
  'm11',
  'm12',
];

export const NOMES_MESES = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
];

/** O que a linha carrega ENQUANTO é digitada: projetos ainda como texto. */
export type LinhaMes = { projetos: string; valor: number | null };

export function mesesVazios(): Record<ChaveMes, LinhaMes> {
  const inicial = {} as Record<ChaveMes, LinhaMes>;
  for (const chave of CHAVES) inicial[chave] = { projetos: '', valor: null };
  return inicial;
}

/** Projeto é unidade inteira. Campo vazio ou negativo vale 0. */
export function inteiroDe(texto: string): number {
  const n = parseFloat(texto);
  return Number.isFinite(n) && n > 0 ? Math.round(n) : 0;
}
